import styled from 'styled-components';
import { HTMLProps } from '@ch/common/utils';
import { ColorProps, colors } from '@ch/common/const/color';
import { font } from '@ch/common/const/font';
import { IconStyled } from '@ch/common/components/icon';

export const HeaderStyled = styled.header<HTMLProps<HTMLDivElement> & { $color: ColorProps; $bgColor?: string }>`
  display: block;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: ${colors.grayLighter};
  ${({ $color, $bgColor }) =>
    $color &&
    `
    ${$color === 'white' ? `box-shadow: inset 0px -1px 0px ${colors.grayLight};` : ''}
    background-color: ${$bgColor || colors[$color]};
  `}
`;

export const HeaderInner = styled.div<HTMLProps<HTMLDivElement>>`
  display: flex;
  justify-content: space-between;
`;

export const HeaderBlock = styled.div<HTMLProps<HTMLDivElement>>`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 15px 10px;
`;

export const HeaderLogo = styled.img<HTMLProps<HTMLImageElement>>`
  width: 160px;
  height: 32px;
  display: block;
`;

export const HeaderDivider = styled.div<HTMLProps<HTMLDivElement>>`
  width: 0;
  height: 40px;
  margin: 0 25px;
  border-right: 1px solid ${colors.grayMedium};
`;

export const HeaderUserWrap = styled.div<HTMLProps<HTMLDivElement>>`
  display: flex;
  align-items: center;
  position: relative;
`;

export const HeaderUserIcon = styled.span`
  padding: 5px;
  border: none;
  margin: 2px;
`;

export const HeaderUserToggle = styled.button<HTMLProps<HTMLButtonElement> & { $active?: boolean }>`
  cursor: pointer;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  color: ${({ $active }) => ($active ? colors.primary : colors.black)};
  background-color: ${({ $active }) => ($active ? colors.primaryLight : colors.transparent)};
  ${HeaderUserIcon} {
    transform: rotate(${({ $active }) => ($active ? '180deg' : '0deg')});
    * {
      fill: ${({ $active }) => ($active ? colors.primary : colors.black)};
    }
  }
`;

export const HeaderUserName = styled.span<HTMLProps<HTMLSpanElement>>`
  font-size: ${font.size.sm}px;
  margin-left: 5px;
`;

export const HeaderUserDropdown = styled.div<HTMLProps<HTMLDivElement>>`
  min-width: 100%;
  position: absolute;
  top: 100%;
  left: 0;
  margin: 0;
  z-index: 10;
  background: ${colors.white};
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.1);
`;

export const HeaderUserDropdownItem = styled.button<HTMLProps<HTMLButtonElement>>`
  width: 100%;
  display: block;
  text-align: left;
  border: none;
  background: transparent;
  padding: 10px 15px;
  font-size: ${font.size.sm}px;
  color: ${colors.black};
  cursor: pointer;
  &:hover {
    color: ${colors.primary};
  }
`;

export const HeaderActivityToggle = styled.button<HTMLProps<HTMLButtonElement> & { $active?: boolean }>`
  width: 48px;
  height: 48px;
  padding: 10px;
  background: ${({ $active }) => ($active ? colors.primaryLight : colors.transparent)};
  border-radius: 8px;
  display: block;
  border: none;
  cursor: pointer;
  margin-left: 5px;
  ${IconStyled} {
    margin-bottom: -2px;
    * {
      fill: ${({ $active }) => ($active ? colors.primary : colors.black)};
    }
  }
`;

export const HeaderNavWrap = styled.div`
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
`;

export const HeaderExpert = styled.div`
  color: ${colors.primary};
  border: none;
  background: white;
  cursor: pointer;
  padding: 7px 12px;
  border-radius: 6px;
  font-weight: 600;
  border-left: 1px solid ${colors.grayMedium};
  display: flex;
  align-items: center;
`;
